import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminAdmins_id = z.any()
export type TagsGetAdminAdmins_id = z.infer<typeof tagsGetAdminAdmins_id>

export const paramsGetAdminAdmins_id = z.object({ "id": z.string() })
export type ParamsGetAdminAdmins_id = z.infer<typeof paramsGetAdminAdmins_id>

export const responseGetAdminAdmins_id = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "email": z.string().email(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "privileges": z.array(z.string()) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminAdmins_id = z.infer<typeof responseGetAdminAdmins_id>

interface IGetAdminAdmins_id extends BaseMethodType {
  tags: TagsGetAdminAdmins_id,
  params: ParamsGetAdminAdmins_id,
  response: ResponseGetAdminAdmins_id
}
export const tagsPatchAdminAdmins_id = z.any()
export type TagsPatchAdminAdmins_id = z.infer<typeof tagsPatchAdminAdmins_id>

export const paramsPatchAdminAdmins_id = z.object({ "id": z.string() })
export type ParamsPatchAdminAdmins_id = z.infer<typeof paramsPatchAdminAdmins_id>

export const bodyPatchAdminAdmins_id = z.object({ "user": z.object({ "name": z.string().optional(), "email": z.string().email().optional(), "verifiedEmail": z.boolean().optional(), "verifiedByAdmin": z.boolean().optional() }).optional(), "privileges": z.array(z.string()).optional() })
export type BodyPatchAdminAdmins_id = z.infer<typeof bodyPatchAdminAdmins_id>

export const responsePatchAdminAdmins_id = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "email": z.string().email(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "privileges": z.array(z.string()) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchAdminAdmins_id = z.infer<typeof responsePatchAdminAdmins_id>

interface IPatchAdminAdmins_id extends BaseMethodType {
  tags: TagsPatchAdminAdmins_id,
  params: ParamsPatchAdminAdmins_id,
  body: BodyPatchAdminAdmins_id,
  response: ResponsePatchAdminAdmins_id
}
export const tagsDeleteAdminAdmins_id = z.any()
export type TagsDeleteAdminAdmins_id = z.infer<typeof tagsDeleteAdminAdmins_id>

export const paramsDeleteAdminAdmins_id = z.object({ "id": z.string() })
export type ParamsDeleteAdminAdmins_id = z.infer<typeof paramsDeleteAdminAdmins_id>

export const responseDeleteAdminAdmins_id = z.any()
export type ResponseDeleteAdminAdmins_id = z.infer<typeof responseDeleteAdminAdmins_id>

interface IDeleteAdminAdmins_id extends BaseMethodType {
  tags: TagsDeleteAdminAdmins_id,
  params: ParamsDeleteAdminAdmins_id,
  response: ResponseDeleteAdminAdmins_id
}
export const URL = '/admin/admins/:id'
export const validation = {
  get: {
    tags: tagsGetAdminAdmins_id,
    params: paramsGetAdminAdmins_id,
    response: responseGetAdminAdmins_id
  },
  patch: {
    tags: tagsPatchAdminAdmins_id,
    params: paramsPatchAdminAdmins_id,
    body: bodyPatchAdminAdmins_id,
    response: responsePatchAdminAdmins_id
  },
  delete: {
    tags: tagsDeleteAdminAdmins_id,
    params: paramsDeleteAdminAdmins_id,
    response: responseDeleteAdminAdmins_id
  }
}
export interface AdminAdmins_id extends BaseRouteType {
  get: IGetAdminAdmins_id,
  patch: IPatchAdminAdmins_id,
  delete: IDeleteAdminAdmins_id
}